export const FLIGHTS_ENTITY_NAMES_MAP_VALUE = 1;
export const DINING_ENTITY_NAMES_MAP_VALUE = 2;
export const LODGING_ENTITY_NAMES_MAP_VALUE = 4;
export const LODGING_AND_CAR_ENTITY_NAMES_MAP_VALUE = 12;
export const LODGING_AND_FLIGHTS_AND_CAR_ENTITY_NAMES_MAP_VALUE = 13;
export const RENTAL_CAR_ENTITY_NAMES_MAP_VALUE = 8;
export const PACKAGE_ENTITY_NAMES_MAP_VALUE = 16;
export const EVENTS_ENTITY_NAMES_MAP_VALUE = 32;
export const INVOICE_ENTITY_NAMES_MAP_VALUE = 64;
export const SERVICE_RESERVATION_ENTITY_NAMES_MAP_VALUE = 128;
export const UNSUCCESSFUL_FLIGHTS_ENTITY_NAMES_MAP_VALUE = 4294967296;
export const UNSUCCESSFUL_LODGING_ENTITY_NAMES_MAP_VALUE = 8589934592;
export const UNSUCCESSFUL_RENTAL_ENTITY_NAMES_MAP_VALUE = 17179869184;
